export default __webpack_public_path__ + "static/media/check.bba34c08.svg";